<template>
    <Key v-if="icon == 'Key'" />
    <List v-if="icon == 'List'" />
    <Setting v-if="icon == 'Setting'" />
    <Aim v-if="icon == 'Aim'" />
    <UserFilled v-if="icon == 'UserFilled'" />
    <Link v-if="icon == 'Link'" />
    <Connection v-if="icon == 'Connection'" />
    <Menu v-if="icon == 'Menu'" />
    <Grid v-if="icon == 'Grid'" />
    <Message v-if="icon == 'Message'" />
    <User v-if="icon == 'User'" />
    <Eleme v-if="icon == 'Eleme'" />
    <Folder v-if="icon == 'Folder'" />
    <Refresh v-if="icon == 'Refresh'" />
    <SetUp v-if="icon == 'SetUp'" />
    <ChatDotSquare v-if="icon == 'ChatDotSquare'" />
    <Star v-if="icon == 'Star'" />

</template>
<script>
    export default {
        name: "Icon",
        props: {
            icon: {
                type: String,
                required: true
            }
        }
    };
</script>